/**
 * This function is part of a migration from storing file sizes in bytes
 * as integers to storing them in kilobytes as strings.
 */
export const toSizeInKb = (sizeInBytes: number): string => {
  const converted = isNaN(sizeInBytes / 1000) ? 0 : sizeInBytes / 1000;
  return Math.max(1, converted).toFixed();
};
